import React from "react";
import IcoMoon from "icomoon-react";
import iconSet from "./selection.json";

const Icomoon = ({ ...props }) => {
  return <IcoMoon iconSet={iconSet} {...props} />;
};

export default Icomoon;